const isProd = String(process.env.NODE_ENV).toLowerCase() === 'production'

function getServerConfiguration() {
  if (isProd)
    return {
      baseURL: 'https://mandc.mandc.co.in/',
    }

  return {
    baseURL: 'https://prodlb3.mandc.co.in/',
  }
}
const serverConfig = getServerConfiguration()

export default { serverConfig }
